// extracted by mini-css-extract-plugin
module.exports = {"input-validation-message":"InputValidationMessage_input-validation-message__2jloQ","otp-validation-message":"InputValidationMessage_otp-validation-message__2VTKS"};